// extracted by mini-css-extract-plugin
module.exports = {"heading":"styles_heading__WxWlX","bookingReference":"styles_bookingReference__n4BrN","buttons":"styles_buttons__jbLA_"};